// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.showing-feedback-container {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  min-height: 91.4vh;
  background-color: #F9FAFC;
}
.showing-feedback-container .nav, .showing-feedback-container .form {
  margin-top: 20px;
}
.showing-feedback-container .nav {
  grid-area: 1/1/2/3;
  position: fixed;
  width: 25%;
  left: 0;
  height: 91.4vh;
}
.showing-feedback-container .form {
  grid-area: 1/3/2/9;
  overflow: hidden;
  background-color: white;
  border-radius: 15px;
  margin-right: 90px;
  margin-bottom: 50px;
  padding: 50px;
}
.showing-feedback-container .form ::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  opacity: 0;
}
.showing-feedback-container .form:hover {
  /* Track */
  /* Handle */
  /* Handle on hover */
}
.showing-feedback-container .form:hover ::-webkit-scrollbar {
  opacity: 1;
}
.showing-feedback-container .form:hover ::-webkit-scrollbar-track {
  border-radius: 10px;
}
.showing-feedback-container .form:hover ::-webkit-scrollbar-thumb {
  background: #b4b4b4;
  border-radius: 10px;
}
.showing-feedback-container .form:hover ::-webkit-scrollbar-thumb:hover {
  background: #b4b4b4;
}
.showing-feedback-container .form .manage-listing-calendar-container {
  animation: fadeIn 0.5s;
}
.showing-feedback-container .form .manage-listing-calendar-container .header {
  display: flex;
  align-items: center;
}
.showing-feedback-container .form .manage-listing-calendar-container .header > p {
  margin: 0;
  font-family: "Proxima Nova", sans-serif;
  font-weight: 700;
  color: var(--secondary-color-1);
  font-size: 20px;
  margin-left: 10px;
}
.showing-feedback-container .form .manage-listing-calendar-container .form-section {
  font-family: "Proxima Nova", sans-serif;
  width: 500px;
}
.showing-feedback-container .form .manage-listing-calendar-container .form-section .section-title {
  margin: 0;
  font-weight: 700;
  font-size: 20px;
  color: var(--secondary-color-1);
}
.showing-feedback-container .form .manage-listing-calendar-container .form-section .form-input .options {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500px;
  color: #6C767C;
  margin-top: 15px;
}
.showing-feedback-container .form .manage-listing-calendar-container .form-section .form-input > label {
  font-size: 14px;
  font-weight: 600;
  color: var(--secondary-color-5);
  display: flex;
  align-items: center;
}
.showing-feedback-container .form .manage-listing-calendar-container .form-section .form-input > label span.tooltip {
  position: relative;
  cursor: pointer;
}
.showing-feedback-container .form .manage-listing-calendar-container .form-section .form-input > label span.tooltip:before {
  content: attr(data-text);
  position: absolute;
  top: -50px;
  left: 10px;
  margin-left: 15px;
  width: 200px;
  padding: 10px;
  border-radius: 10px;
  background: var(--secondary-color-1);
  color: #fff;
  text-align: center;
  font-size: 12px;
  display: none;
}
.showing-feedback-container .form .manage-listing-calendar-container .form-section .form-input > label span.tooltip:hover:before {
  display: block;
}
.showing-feedback-container .form .manage-listing-calendar-container .form-section .form-input > input {
  font-family: "Proxima Nova", sans-serif;
  margin-top: 10px;
}
.showing-feedback-container .form .manage-listing-calendar-container .form-section .form-input > input::placeholder {
  font-family: "Proxima Nova", sans-serif;
}
.showing-feedback-container .form .manage-listing-calendar-container .form-section .input-choices {
  position: relative;
}
.showing-feedback-container .form .manage-listing-calendar-container .form-section .input-choices > input {
  margin-top: 10px;
}
.showing-feedback-container .form .manage-listing-calendar-container .form-section .input-choices .form-choices {
  max-height: 300px;
  border-radius: 15px;
  background-color: white;
  box-shadow: 0px 4px 20px rgba(53, 99, 55, 0.2);
  position: absolute;
  z-index: 99;
  width: 100%;
  overflow: auto;
  padding: 20px;
  margin-top: 0;
  visibility: hidden;
  opacity: 0;
  transition: 0.3s ease-in-out;
  font-family: "Proxima Nova", sans-serif;
}
.showing-feedback-container .form .manage-listing-calendar-container .form-section .input-choices .form-choices.show {
  visibility: visible;
  margin-top: 10px;
  opacity: 1;
}
.showing-feedback-container .form .manage-listing-calendar-container .form-section .input-choices .form-choices > li {
  padding: 10px 0;
  cursor: pointer;
  font-weight: 700;
  transition: 0.3s ease-in-out;
}
.showing-feedback-container .form .manage-listing-calendar-container .form-section .input-choices .form-choices > li:hover {
  opacity: 0.75;
}
.showing-feedback-container .form .manage-listing-calendar-container .form-section .input-choices .form-choices > li.selected {
  color: var(--primary-color-1);
}
.showing-feedback-container .form .image-view-container, .showing-feedback-container .form .delete-image-modal, .showing-feedback-container .form .form-section, .showing-feedback-container .form .form-header-container {
  animation: fadeIn 0.5s;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .listing-form-container .nav {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/ShowingFeeback/showingFeedback.scss","webpack://./src/assets/styles/_mixins.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,qCAAA;EACA,uBAAA;EACA,oBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;AADJ;AAEI;EACI,gBAAA;AAAR;AAEI;EACI,kBAAA;EACA,eAAA;EACA,UAAA;EACA,OAAA;EACA,cAAA;AAAR;AAEI;EACI,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;AAAR;AACQ;EACI,UAAA;EACA,WAAA;EACA,UAAA;AACZ;AACQ;EAII,UAAA;EAIA,WAAA;EAKA,oBAAA;AATZ;AAHY;EACI,UAAA;AAKhB;AAFY;EACI,mBAAA;AAIhB;AADY;EACI,mBAAA;EACA,mBAAA;AAGhB;AAAY;EACI,mBAAA;AAEhB;AACQ;EACI,sBAAA;AACZ;AAAY;EACI,aAAA;EACA,mBAAA;AAEhB;AADgB;EACI,SAAA;EACA,uCAAA;EACA,gBAAA;EACA,+BAAA;EACA,eAAA;EACA,iBAAA;AAGpB;AAAY;EACI,uCAAA;EACA,YAAA;AAEhB;AADgB;EACI,SAAA;EACA,gBAAA;EACA,eAAA;EACA,+BAAA;AAGpB;AAAoB;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;AAExB;AAAoB;EACI,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;AAExB;AADwB;EACI,kBAAA;EACA,eAAA;AAG5B;AAF4B;EACI,wBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,oCAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;AAIhC;AAF4B;EACI,cAAA;AAIhC;AAAoB;EACI,uCAAA;EACA,gBAAA;AAExB;AADwB;EACI,uCAAA;AAG5B;AACgB;EACI,kBAAA;AACpB;AAAoB;EAAU,gBAAA;AAG9B;AAFoB;EACI,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,8CAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,4BAAA;EACA,uCAAA;AAIxB;AAHwB;EACI,mBAAA;EACA,gBAAA;EACA,UAAA;AAK5B;AAHwB;EACI,eAAA;EACA,eAAA;EACA,gBAAA;EACA,4BAAA;AAK5B;AAJ4B;EAAU,aAAA;AAOtC;AAN4B;EAAa,6BAAA;AASzC;AAHQ;EACI,sBAAA;AAKZ;AADI;EACI;IAAK,UAAA;EAIX;EAHM;IAAO,UAAA;EAMb;AACF;;ACtKY;EDsKJ;IAAO,aAAA;EAKb;AACF","sourcesContent":["@import 'assets/styles/_mixins.scss';\r\n\r\n.showing-feedback-container {\r\n    display: grid;\r\n    grid-template-columns: repeat(8, 1fr);\r\n    grid-template-rows: 1fr;\r\n    grid-column-gap: 0px;\r\n    grid-row-gap: 0px;\r\n    min-height: 91.4vh;\r\n    background-color: #F9FAFC;\r\n    .nav, .form {\r\n        margin-top: 20px;\r\n    }\r\n    .nav { \r\n        grid-area: 1 / 1 / 2 / 3;;\r\n        position: fixed;\r\n        width: 25%;\r\n        left: 0;\r\n        height: 91.4vh;\r\n    }\r\n    .form { \r\n        grid-area: 1 / 3 / 2 / 9;\r\n        overflow: hidden;\r\n        background-color: white;\r\n        border-radius: 15px;\r\n        margin-right: 90px;\r\n        margin-bottom: 50px;\r\n        padding: 50px;\r\n        ::-webkit-scrollbar {\r\n            width: 5px;\r\n            height: 5px;\r\n            opacity: 0;\r\n        }\r\n        &:hover {\r\n            ::-webkit-scrollbar {\r\n                opacity: 1;\r\n            }\r\n            /* Track */\r\n            ::-webkit-scrollbar-track {\r\n                border-radius: 10px;\r\n            }\r\n            /* Handle */\r\n            ::-webkit-scrollbar-thumb {\r\n                background: #b4b4b4; \r\n                border-radius: 10px;\r\n            }\r\n            /* Handle on hover */\r\n            ::-webkit-scrollbar-thumb:hover {\r\n                background: #b4b4b4; \r\n            }\r\n        }\r\n        .manage-listing-calendar-container {\r\n            animation: fadeIn .5s;\r\n            .header {\r\n                display: flex;\r\n                align-items: center;\r\n                > p {\r\n                    margin: 0;\r\n                    font-family: 'Proxima Nova', sans-serif;\r\n                    font-weight: 700;\r\n                    color: var(--secondary-color-1);\r\n                    font-size: 20px;\r\n                    margin-left: 10px;\r\n                }\r\n            }\r\n            .form-section {\r\n                font-family: 'Proxima Nova', sans-serif;\r\n                width: 500px;\r\n                .section-title {\r\n                    margin: 0;\r\n                    font-weight: 700;\r\n                    font-size: 20px;\r\n                    color: var(--secondary-color-1);\r\n                }\r\n                .form-input {\r\n                    .options {\r\n                        display: flex;\r\n                        align-items: center;\r\n                        font-size: 14px;\r\n                        font-weight: 500px;\r\n                        color: #6C767C;\r\n                        margin-top: 15px;\r\n                    }\r\n                    > label {\r\n                        font-size: 14px;\r\n                        font-weight: 600;\r\n                        color: var(--secondary-color-5);\r\n                        display: flex;\r\n                        align-items: center;\r\n                        span.tooltip {\r\n                            position: relative;\r\n                            cursor: pointer;\r\n                            &:before {\r\n                                content: attr(data-text);\r\n                                position:absolute;\r\n                                top: -50px;\r\n                                left: 10px;\r\n                                margin-left: 15px;\r\n                                width: 200px;\r\n                                padding: 10px;\r\n                                border-radius: 10px;\r\n                                background:var(--secondary-color-1);\r\n                                color: #fff;\r\n                                text-align:center;\r\n                                font-size: 12px;\r\n                                display: none;\r\n                            }\r\n                            &:hover:before {\r\n                                display:block;\r\n                            }\r\n                        }\r\n                    }\r\n                    > input {\r\n                        font-family: 'Proxima Nova', sans-serif;\r\n                        margin-top: 10px;\r\n                        &::placeholder {\r\n                            font-family: 'Proxima Nova', sans-serif;\r\n                        }\r\n                    }\r\n                }\r\n                .input-choices {\r\n                    position: relative;\r\n                    > input { margin-top: 10px; }\r\n                    .form-choices {\r\n                        max-height: 300px;\r\n                        border-radius: 15px;\r\n                        background-color: white;\r\n                        box-shadow: 0px 4px 20px rgba(53, 99, 55, 0.2);\r\n                        position: absolute;\r\n                        z-index: 99;\r\n                        width: 100%;\r\n                        overflow: auto;\r\n                        padding: 20px;\r\n                        margin-top: 0;\r\n                        visibility: hidden;\r\n                        opacity: 0;\r\n                        transition: .3s ease-in-out;\r\n                        font-family: 'Proxima Nova', sans-serif;\r\n                        &.show {\r\n                            visibility: visible;\r\n                            margin-top: 10px;\r\n                            opacity: 1;\r\n                        }\r\n                        > li {\r\n                            padding: 10px 0;\r\n                            cursor: pointer;\r\n                            font-weight: 700;\r\n                            transition: .3s ease-in-out;\r\n                            &:hover { opacity: .75; }\r\n                            &.selected { color: var(--primary-color-1); }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n        .image-view-container, .delete-image-modal, .form-section, .form-header-container {\r\n            animation: fadeIn .5s;\r\n        }\r\n    }\r\n\r\n    @keyframes fadeIn {\r\n        0% { opacity: 0; }\r\n        100% { opacity: 1; }\r\n    }\r\n}\r\n\r\n\r\n@include media(mobile) {\r\n    .listing-form-container {\r\n        .nav { display: none; }\r\n    }\r\n}","@mixin media($keys...) {\r\n    @each $key in $keys {\r\n        @if ($key==mobile) {\r\n            @media (min-width: 481px) and (max-width: 767px),\r\n            (min-width: 320px) and (max-width: 480px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==tablet) {\r\n            @media (min-width: 768px) and (max-width: 1024px),\r\n            (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==nitty-gritt) {\r\n            @media (width: 1024px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==small-desktop) {\r\n            @media (max-width: 1440px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==desktop) {\r\n            @media (min-width: 1024px) and (max-width: 1440px) {\r\n                @content;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
